import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EjecucionFiscalInformacionService } from "../../servicios/ejecucion-fiscal-informacion.service";
import { ActivatedRoute, Router } from "@angular/router";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";


import { 
  EjecucionFiscalInformacion ,
  EjecucionFiscalInformacionInput,
  } from "../../entidades/entidades";


@Component({
  selector: "app-ejecucion-fiscal-informacion",
  templateUrl: "./ejecucion-fiscal-informacion.component.html",
  styleUrls: ["./ejecucion-fiscal-informacion.component.css"]
})




export class EjecucionFiscalInformacionComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  ejecucionFiscalInformacionForm: FormGroup;
  @Input("ejecucionFiscalInformacionImput") ejecucionFiscalInformacionImput: EjecucionFiscalInformacionInput;
  @Output("ejecucionFiscalInformacionOutput") ejecucionFiscalInformacionOutput: EventEmitter<EjecucionFiscalInformacion>;

  public cuentaAgua: number;
  constructor(
    private formBuilder: FormBuilder,
    private ejecucionFiscalInformacionService: EjecucionFiscalInformacionService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.ejecucionFiscalInformacionOutput = new EventEmitter()
  }
  ngOnInit() {
    this.ejecucionFiscalInformacionForm = this.formBuilder.group({
      idAgua : [undefined  ],
      cuentaAgua : [undefined ,[Validators.pattern(/^[0-9]+\.?[0-9]*$/)] ],
      nombreCompleto : [undefined  ],
      domicilio : [undefined  ],
      cp : [undefined  ],
      ruta : [undefined ,[Validators.pattern(/^[0-9]+\.?[0-9]*$/)] ],
      numeroMedidor : [undefined  ],
      fechaInstalacion : [undefined  ],
      claveCatastral : [undefined  ],
      rfc : [undefined  ],
      periodo : [undefined ,[Validators.pattern(/^[0-9]+\.?[0-9]*$/)] ],
      tipoPeriodo : [undefined  ],
      anio : [undefined ,[Validators.pattern(/^[0-9]+\.?[0-9]*$/)] ],
      fechaVencimiento : [undefined  ],
      derivada : [undefined ,[Validators.pattern(/^[0-9]+\.?[0-9]*$/)] ],
      anomalia : [undefined  ],
      observaciones : [undefined  ],
      diametro : [undefined  ],
      tipoServicio : [undefined  ],
      proximaLectura : [undefined  ],
      tipoUso : [undefined  ],
      lecturaIni : [undefined ,[Validators.pattern(/^[0-9]+\.?[0-9]*$/)] ],
      lecturaFin : [undefined ,[Validators.pattern(/^[0-9]+\.?[0-9]*$/)] ],
      periodoConsumoIni : [undefined  ],
      periodoConsumoFin : [undefined  ],
      consumo : [undefined ,[Validators.pattern(/^[0-9]+\.?[0-9]*$/)] ],
    });
   // if (this.ejecucionFiscalInformacionImput) this.ejecucionFiscalInformacionForm.patchValue(this.ejecucionFiscalInformacion);
    if (this.ejecucionFiscalInformacionImput) {
      this.getEjecucionFiscalInformacionAll(this.ejecucionFiscalInformacionImput);
    }
 
  }
  

  //====================================================
  //Metodos para obtener datos del servicio
  //====================================================
  async getEjecucionFiscalInformacionAll(ejecucionFiscalInformacionImput: EjecucionFiscalInformacionInput) {
    try {
      const datoRetorno = await this.ejecucionFiscalInformacionService
        .getBusquedas(ejecucionFiscalInformacionImput)
        .toPromise();
      console.log("Ejecucion fiscal informacion", datoRetorno);
      this.ejecucionFiscalInformacionForm.patchValue(datoRetorno[0]);
      //this.estadoCuentaTable = datoRetorno;
            //console.log('sdadawdad', this.datoRetorno);
      this.cuentaAgua = datoRetorno[0].cuentaAgua;
    } catch (e) {
      if (e.response) {
        throw { message: e.response.data };
      } else {
        throw e;
      }
    } finally {
      console.log("Paso por getEjecucionFiscalInformacionAll");
    }
  }


  async getEjecucionFiscalInformacion(id: number) {
    try {
      const datoRetorno = await this.ejecucionFiscalInformacionService
        .getSingle(id)
        .toPromise();
      this.ejecucionFiscalInformacionForm.patchValue(datoRetorno);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getEjecucionFiscalInformacion");
    }
  }

  async getAllEjecucionFiscalInformacion() {
    try {
      const datoRetorno = await this.ejecucionFiscalInformacionService.getAll().toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllEjecucionFiscalInformacion");
    }
  }
}